export interface Event {
  id?: string;
  title: string;
  startDate: string;
  endDate: string;
  location: string;
  locationId?: string; // ID du lieu sélectionné (pour les salles communales)
  googleMapsUrl?: string; // Lien Google Maps
  maxParticipants: number;
  participants: string[];
  zone: 'salle_communale' | 'domicile' | 'wan_online';
  photoAlbumUrl?: string; // Lien vers l'album Google Photos
  isHomeEvent?: boolean; // Indique si c'est un événement à domicile
  isWanEvent?: boolean; // Indique si c'est un événement WAN (en ligne)
  debrief?: {
    content: string;
    lastModified: string;
    modifiedBy: string;
  };
}

// Types de zones pour les événements
export const EVENT_ZONES = {
  COMMUNAL: 'salle_communale',
  HOME: 'domicile',
  WAN: 'wan_online'
} as const;

// Description des zones
export const EVENT_ZONE_DESCRIPTIONS = {
  [EVENT_ZONES.COMMUNAL]: 'Événement en salle communale (accessible à tous les membres)',
  [EVENT_ZONES.HOME]: 'Événement à domicile (accessible aux membres Or et Admin uniquement)',
  [EVENT_ZONES.WAN]: 'WAN - Réseau Online (accessible à tous sauf bronze)'
} as const;
